<template>
  <div class="publish-task-product">
    <steps :active="3"></steps>
    <el-row class="normal-from mobile-container">
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :offset="9" class="mobile-offset">
        <h3>选择支付方式</h3>
        <PayFrom :firstCreate="true" :paymentId="'2'" :showForm="false" :showOffPay="true" v-on:success="submit" class="firstCreate"></PayFrom>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Steps from '../components/Steps'
import PayFrom from './Form'
import api from '../../../services/api.js'

export default {
  name: 'AddAddress',
  components: {
    steps: Steps,
    PayFrom: PayFrom
  },
  computed: {
    taskInfo () {

	    return this.$store.state.taskInfo
    }
  },
  data () {
    return {
    }
  },
  methods: {
    async submit (data) {
      console.log(data)
      let id = await this.savePayment(data)
      this.taskInfo.payment_type_info = data
      this.taskInfo.payment_type_id = id
      this.$store.commit('updateTaskInfo', this.taskInfo)
      this.$router.push({ path: 'confirm' })
    },
    async savePayment (data) {
      let apiPayment = 'add_payment_type';
      if (data.id) {
        apiPayment = 'update_payment_type';
        data.payment_type_id = data.id
      }
      let res = await api.post(this, {
        path: 'buyer.php',
        api: apiPayment,
        data: data,
        loading: 'loading'
      });
      if (data.id) {
        return data.id
      }
      return res.body.result
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@media screen and (max-width:769px){
.mobile-container {
    padding: 0 10px;
    h3 {
      margin: 10px 0 20px;
    }

    .mobile-offset {
      margin-left: 0 !important;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/payment/Payment.vue